module.exports = __webpack_public_path__ + "img/clear_cross.0591a24f.svg";